import { useEffect, useState } from 'react';

import { LanguageContent } from 'src/services/responseTypes/singleLaunchResponse';
import { langaugeComparator } from 'src/utils/LanguageUtils';

import { useAppStore } from 'src/hooks/useAppStore';
import * as style from './ContentLanguageStyle';
import { CheckBox, Label, Row } from './ContentLanguageStyle';

//types
type ContentLanguagePropsType = {
  selectedLanguages: string[];
  handleChange: (languages: string[]) => void;
  showPrimaryLanguages: boolean;
};

const ContentLanguage = ({
  selectedLanguages,
  handleChange,
  showPrimaryLanguages
}: ContentLanguagePropsType) => {
  const { initialLaunchData } = useAppStore();
  const contentLanguagesList = initialLaunchData?.getlang.content || [];

  const sortAndFormatLanguages = (languages: LanguageContent[] | undefined) => {
    return (
      languages
        ?.map((language) => {
          const is_default = selectedLanguages.find(
            (langCode: string) => langCode === language.l_code
          )
            ? '1'
            : '0';
          return { ...language, is_default };
        })
        .sort(langaugeComparator) || []
    );
  };

  //hooks
  const [contentLanguages, setContentLanguages] = useState(
    sortAndFormatLanguages(contentLanguagesList)
  );

  useEffect(() => {
    const selectContentLanguages = contentLanguages
      ?.filter((language) => {
        return language.is_default === '1';
      })
      .map((language) => language.l_code);
    if (selectContentLanguages) handleChange(selectContentLanguages);
  }, [contentLanguages]);

  const handleCheckBoxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    setContentLanguages((ps) => {
      return ps?.map((language) => {
        if (language.name === name)
          return {
            ...language,
            is_default: language.is_default === '1' ? '0' : '1'
          };
        return { ...language };
      });
    });
  };

  return (
    <>
      {contentLanguages && contentLanguages.length > 0
        ? contentLanguages
            .filter((lang) =>
              showPrimaryLanguages ? lang.category === '1' : true
            )
            .map((language) => {
              return (
                <Row
                  key={language.name}
                  css={[language.is_default === '1' && style.active]}>
                  <Label>
                    <div css={style.languageContainer}>
                      <div css={style.dot}></div>
                      <span css={style.langName}>{language.native}</span>
                      <span
                        css={style.commonName}
                        data-testid={language.name.toLowerCase() + '-label'}>
                        {language.name}
                      </span>
                    </div>
                    <div>
                      <CheckBox
                        type="checkbox"
                        checked={language.is_default === '1'}
                        onChange={(event) =>
                          handleCheckBoxChange(event, language.name)
                        }
                        data-testid={
                          language.name.toLowerCase() + '-label-checkbox'
                        }
                      />
                      <div
                        css={[
                          style.checkBoxOuter,
                          language.is_default === '1' && style.activeBox,
                          language.is_default === '1' && style.checkIcon
                        ]}></div>
                    </div>
                  </Label>
                </Row>
              );
            })
        : null}
    </>
  );
};

export default ContentLanguage;
